<template>
  <div>
    <ul class="-my-5 -mx-6 divide-y divide-gray-200">
      <li>
        <button
          class="w-full text-left flex items-center space-x-4 px-4 py-4 focus:outline-none focus:bg-gray-50"
          @click="setOption('status')"
        >
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate">Status</p>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </button>
      </li>

      <!-- <li>
        <button
          class="w-full text-left flex items-center space-x-4 px-4 py-4 focus:outline-none focus:bg-gray-50"
          @click="setOption('product')"
        >
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate">
              Product
            </p>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </button>
      </li> -->

      <li>
        <button
          class="w-full text-left flex items-center space-x-4 px-4 py-4 focus:outline-none focus:bg-gray-50"
          @click="setOption('date_created')"
        >
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 truncate">Date Created</p>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    setOption(option) {
      this.$emit('set-option', option);
    },
  },
};
</script>
